import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from 'seagull';
import ExternalLinkButton from '~/components/ExternalLinkButton';
export const LevvySteps = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: "2. In Levvy, open the Integrations page, find Anchor, and click Connect."
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: "3. When prompted, paste your API key into the Anchor API Key field"
            }),
            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                href: "http://help.sayanchor.com/en/articles/13003522-levvy",
                openInNewTab: true,
                style: {
                    marginTop: 16
                },
                testId: "levvy-help-center-link",
                bi: {
                    name: 'levvy_help_center_link'
                },
                children: "Read more in the Help Center"
            })
        ]
    });
